import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;

  /* Ensure row fits the parent width without inner horizontal scroll or shrinkage */
  .row {
    margin-left: -18px;
    margin-right: -18px;
  }

  /* Card Layout */
  .card-box {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  /* Responsive Grid Adjustments matching col-md-9 and col-md-3 */
  @media (min-width: 768px) {
    .row > .col-md-9 {
      width: 75% !important;
      max-width: 75% !important;
    }

    .row > .col-md-3 {
      width: 25% !important;
      max-width: 25% !important;
    }
  }

  /* Carousel Image Heights */
  .carousel,
  .carousel-inner,
  .carousel-item {
    height: 100%;
  }

  .carousel-inner img {
    width: 100%;
    height: 100%;
    min-height: 280px;
    max-height: 350px;
    object-fit: inherit;
    border-radius: 6px;
  }

  .pm-img-frame {
    padding: 3px;
    background-color: #fff;
    border-radius: 4px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    // min-height: 230px;
  }

  .pm-img-frame img {
    width: 100%;
    height: 100%;
    max-height: 290px;
    object-fit: cover;
    object-position: top center;
  }

  .pm-name {
    color: #1a365d;
    font-weight: 700;
    font-size: 1.05rem;
    margin-bottom: 2px;
  }

  .pm-title {
    color: #555555;
    font-size: 0.85rem;
    font-weight: 500;
    margin-bottom: 0;
  }

  /* Carousel Controls */
  .carousel-indicators [data-bs-target] {
    background-color: #c91bac;
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    background-color: #c91bac;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background-size: 60% 60%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: 5%;
  }

  @media (max-width: 768px) {
    .carousel-inner img {
      min-height: 200px;
      max-height: 240px;
    }

    .pm-img-frame {
      min-height: 200px;
    }
  }
`;

export default Wrapper;